export const tableListaKontProfilu = [
    {accessorKey: "id", header: "ID użytkownika"},
    {accessorKey: "name", header: "Login"},
    {accessorKey: "email", header: "Email"},
    {accessorKey: "imie", header: "Imię"},
    {accessorKey: "nazwisko", header: "Nazwisko"},
];
